type OperationalLogContext = Record<string, unknown>;

const normalizeError = (error: unknown) => {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  return {
    message: typeof error === "string" ? error : "Erro não identificado",
    raw: error,
  };
};

/**
 * Logger operacional centralizado.
 * Integrações com Sentry/Datadog podem ser adicionadas aqui sem alterar os handlers de falha.
 */
export function logOperationalError(event: string, error: unknown, context: OperationalLogContext = {}) {
  const payload = {
    event,
    timestamp: new Date().toISOString(),
    error: normalizeError(error),
    context,
  };

  console.error("[operational-error]", payload);
}

export function logOperationalWarning(event: string, context: OperationalLogContext = {}) {
  console.warn("[operational-warning]", {
    event,
    timestamp: new Date().toISOString(),
    context,
  });
}

export function logOperationalInfo(event: string, context: OperationalLogContext = {}) {
  if (!import.meta.env.DEV) return;

  console.info("[operational-info]", {
    event,
    timestamp: new Date().toISOString(),
    context,
  });
}
